import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { extractYoutubeId } from "utils/youtube";
import { extractSpotifyId } from "utils/spotify";

// Landing point for the OS share sheet (see share_target in
// manifest.json/manifest.prod.json) - sharing a YouTube video or a
// Spotify track and picking this (installed) app launches it here with
// the link attached as a query param, so this just hands off straight
// into "propose a song" with it pre-filled (SongEditPage's own autofill
// then takes it from there - see runYoutubeLookup/runSpotifyLookup).
// Android/Chrome only - iOS has never implemented share_target for
// home-screen web apps, so this route is simply never reached there.
//
// Which query param actually holds the link isn't consistent across
// sharing apps - some populate a clean `url`, others fold everything
// (including the link, plus arbitrary surrounding text) into `text`
// instead - so both are checked, url first. Either way, a canonical
// link is rebuilt from just the extracted id rather than passing the
// raw param through as-is, so the field never ends up showing something
// like "Check this out: https://youtu.be/xyz".
export default () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const videoId = extractYoutubeId(params.get("url")) || extractYoutubeId(params.get("text"));
  const youtubeLink = videoId ? `https://www.youtube.com/watch?v=${videoId}` : "";
  // Unlike youtubeLink above, this is passed through as the bare id, not
  // a rebuilt link - SongCreateContainer forwards it straight into
  // SongEditPage's `song.spotify_id` prop, and that's exactly the shape
  // an existing song's spotify_id already has (the Song model only ever
  // stores the bare id) - SongEditPage's own init logic already knows
  // how to turn that into a canonical spotify:track:<id> form value.
  const spotifyId = extractSpotifyId(params.get("url")) || extractSpotifyId(params.get("text"));

  return <Redirect to={{ pathname: "/songs/new", state: { youtubeLink, spotifyId } }} />;
};
